import styled from 'styled-components';
import Select from '@material-ui/core/Select';

export const StyledSelect = styled(Select)`
    width: 200px;
    font-family: 'Manrope', sans-serif;
`